import { render } from "./ProvinceTable.vue?vue&type=template&id=11decdba&scoped=true&ts=true"
import script from "./ProvinceTable.ts?vue&type=script&lang=ts"
export * from "./ProvinceTable.ts?vue&type=script&lang=ts"

import "./ProvinceTable.scss?vue&type=style&index=0&id=11decdba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11decdba"]])

export default __exports__